/* global angular */

export default function() {
  'ngInject';

  const vm = this;
  vm.$onChanges = init;

  function init() {
    $('#donut-element').empty();
    const morrisConfig = {
      resize: true,
      element: 'donut-element',
      data: angular.copy(vm.data)
    };
    window.Morris.Donut(morrisConfig);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/donutChart/controller.js